<template>
  <b-row class="base-row-padded">
    <b-col>
      <DevicesViewer />
    </b-col>
  </b-row>
</template>

<script>
import DevicesViewer from '@/components/DevicesViewer.vue';

export default {
  components: { DevicesViewer },

};
</script>
